import React from 'react';
import { NavLink } from 'react-router-dom';

const AddEventCrumb = () => <NavLink to="/admin/events/add">Add Event</NavLink>;

export default AddEventCrumb;
